import React, { useEffect, useMemo, useState } from "react";
import api from "../services/api";
import {Breadcrumb,Col,Grid,Row,Space,Typography,} from "antd";
import { useLanguage } from "../providers/LanguageProvider";
import ProfilePageHeader from "src/components/profilePage/ProfilePageHeader";
import ProfileSummary from "src/components/profilePage/ProfileSummary";
import ProfileUpdate from "src/components/profilePage/ProfileUpdate";




const ProfilePage: React.FC = () => {
  const { t } = useLanguage();

  return (
      

      <Space direction="vertical" size={16} style={{ width: "100%" }}>
        <ProfilePageHeader />

        <Row gutter={[16, 16]}>
          {/* Sol özet kartı */}
          <Col xs={24} lg={8}>
            <ProfileSummary />
          </Col>

          {/* Sağ: Sekmeli içerik */}
          <Col xs={24} lg={16}>
            <ProfileUpdate />
          </Col>
        </Row>
      </Space>
  );
};

export default ProfilePage;
